import { useEffect, useState  } from 'react';
import axios from "axios";
import { useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import parse from 'wellknown';
import { setQueryParam } from '../Utils/utils';

const MapEvents = ( props ) => {

    const { fetchMapElements, 
      filters, 
      getZoomLevel, 
      isComboRoute,
    } = props

    //const DefaultLink = "https://localhost:44360/Umbraco/Api/RouteTest/Get";
    const DefaultLink = "/umbraco/api/routeTest/get"

    const searchBody = {
      "method": "searchAdvanced",
      "params": [
          {
              "bounds": {
                  "min": {
                    "lon": 3.0157470703125004,
                    "lat": 50.369992582877195,
                  },
                  "max": {
                    "lon": 5.960083007812501,
                    "lat": 51.614605707797494,
                  }
              },
              "permission.readable": true,
              "bounds.comparator": "geometry",
              "language": "nl",
              "group.id": [1933],
              "owner.id": [30581],
              "exclude.group.id": [55551],
          },
          "score DESC",
          100, //limit
          0, //offset
          {
              "media": true,
              "clusters": true
          }
      ]
    }

    const mMap = useMap();

    const [routesData, setRoutesData] = useState([]);
    const [mapElements, setMapElements] = useState({});
    const [combinedRoutesData, setCombindedRoutesData] = useState([]);
    const [center, setCenter] = useState();

    useEffect(() => {
      async function changeMapElements(){
        await fetchRoutes();
      };
      changeMapElements();
    },[filters, isComboRoute]);

    useEffect(() => {

      if( combinedRoutesData.length === 2 ){
        const total = combinedRoutesData[0]["total"] + combinedRoutesData[1]["total"]
        const allRoutes = []
        if(total <= 200){
          const routeArr1 = combinedRoutesData[0].routes,
          routeArr2 = combinedRoutesData[1].routes;
  
          routeArr1.forEach(el => {
            allRoutes.push(el);
          });
          routeArr2.forEach(el => {
            allRoutes.push(el);
          })
        }
  
        const combinedClusters = combineClusters()
  
        const newRoutesObject = {
          "routes":allRoutes,
          "clusters":combinedClusters,
          "total":total
        }
        setRoutesData(newRoutesObject)
      }
    }, [combinedRoutesData]);

    useEffect(() => {
      async function fetchData() {
        var clusterData = []
        var routeData = []

        if(routesData.clusters !== undefined && routesData.routes !== undefined){
          if(routesData.total > 150){
            for(const cluster of routesData.clusters){
              var bounds = [],
              Bsplit = cluster.bounds.wkt.split("("),
              Csplit = Bsplit[1].split(",");

              for(const data of Csplit){
                var point = `POINT(${data})`,
                geoJsonObject = L.geoJson(parse(point)),
                layer = geoJsonObject.getLayers(),
                coordinates = layer[0].feature.geometry.coordinates;  
                coordinates.reverse();         
                bounds.push(coordinates)
              }

              clusterData.push({
                total: cluster.total,
                bounds: [bounds]
              })
            }
          }

          if(routesData.total <= 150){
            let allRouteids = []
            
            routesData.routes.forEach(route => {
              allRouteids.push(route.id)
            })

            await fetchRouteDetails(allRouteids)
            .then(response => {
              for(const route of routesData.routes) {
                if(route.type.id === 10) return
                //Convert start point coordinates
                var geoJsonObject = L.geoJson(parse(route.begin.wkt));
                var layer = geoJsonObject.getLayers()
                var coordinates = layer[0].feature.geometry.coordinates;
    
                //Check route image
                var image = "/images/placeholder.png";
                if(route?.media?.length > 0){
                  route.media.some(media => {
                    if(!(media.source?.name?.nl && media.source.name.nl === "YouTube")){ 
                      image = media?.uri?.nl
                    }
                  });
                }

                //Check route color
                var color = "#ff0000"
                if(route.configuration !== null){
                  if(route.configuration.line !== undefined){
                    color = route.configuration.line.normal.standard.color
                  }
                }

                routeData.push({
                  id: route.id,
                  source: markerImageSelector(route.type.id),
                  position: [coordinates[1], coordinates[0]],
                  name: route.name.nl,
                  type: route.type.id,
                  distance: route.length / 1000,
                  imageUrl: image,
                  routeColor: color,
                  routing: response.data[route.id].geometry.google,
                  description: response.data[route.id].description.nl,
                })
              }
            })
          }

          if(routeData.length > 0)
            routeData = sortRoutes(routeData);

          setMapElements({
            data: {
              clusters: clusterData,
              routes: routeData
            }
          })

        }
      }
      fetchData();
    },[routesData]);

    useEffect(() => {
      fetchMapElements(mapElements);
    },[mapElements]);

    const calculateDistance = (coord1, coord2) => {
      const { lat: lat1, lng: lon1 } = coord1;
      const { lat: lat2, lng: lon2 } = coord2;
      const earthRadius = 6371; // Earth's radius in kilometers
      const latDiff = degToRad(lat2 - lat1);
      const lonDiff = degToRad(lon2 - lon1);
      const a =
        Math.sin(latDiff / 2) * Math.sin(latDiff / 2) +
        Math.cos(degToRad(lat1)) * Math.cos(degToRad(lat2)) *
        Math.sin(lonDiff / 2) * Math.sin(lonDiff / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = earthRadius * c;
      return distance;
    };

    const degToRad = (deg) => {
      return deg * (Math.PI / 180);
    };

    const sortRoutes = (routes) => {
      const sortedRoutes = [...routes].sort(
        (item1, item2) =>
          calculateDistance(L.latLng(item1.position[0], item1.position[1]), center) - calculateDistance(L.latLng(item2.position[0], item2.position[1]), center)
      );
      return sortedRoutes;
    };
  
    const combineClusters = () => {
      var allRouteData = [],
      clustersArr1 = combinedRoutesData[0].clusters,
      clustersArr2 = combinedRoutesData[1].clusters;

      clustersArr1.forEach(ca1Element => {
        clustersArr2.forEach(ca2Element => {
          if(ca1Element.bounds.wkt === ca2Element.bounds.wkt){
            allRouteData.push({
              bounds:{
                wkt: ca2Element.bounds.wkt
              },
              total: ca1Element.total + ca2Element.total
            })
          }
        })
      });
      
      let resultAr1 = clustersArr1.filter(ca1 => !allRouteData.some(cc => ca1.bounds.wkt === cc.bounds.wkt));
      resultAr1.forEach(el => {
        allRouteData.push({
          bounds:{
            wkt: el.bounds.wkt
          },
          total: el.total
        })
      });

      let resultAr2 = clustersArr2.filter(ca2 => !allRouteData.some(cc => ca2.bounds.wkt === cc.bounds.wkt));
      resultAr2.forEach(el => {
        allRouteData.push({
          bounds:{
            wkt: el.bounds.wkt
          },
          total: el.total
        })
      });
      return allRouteData
    };

    const markerImageSelector = (typeId) => {
      let image = ""
      //let baseUrl ="/assets/images/markers"
      let baseUrl ="/images/markers"
      switch(typeId){
        case 9:
        case 25:
        case 26:
        case 49:
          image = `${baseUrl}/runMarker`
          break;
        
        case 17:
        case 35:
        case 36:
          image=`${baseUrl}/horsebackMarker`
          break;
        
        case 7:
          image=`${baseUrl}/mountainbikeMarker`
          break;

        case 16:
        case 32:
          image=`${baseUrl}/kayakMarker`
          break;

        case 19:
          image=`${baseUrl}/skateMarker`
          break;

        case 2:
        case 8:
          image=`${baseUrl}/multiMoveMarker`
          break;
      }
      return image
    };

    const calculateCenter = (bounds) => {
      const latCenter = (bounds._northEast.lat + bounds._southWest.lat) / 2;
      const longCenter = (bounds._northEast.lng + bounds._southWest.lng) / 2;

      setCenter(L.latLng(latCenter, longCenter));
      return L.latLng(latCenter, longCenter);
    }

    const changeBounds = () => {
      setMapElements({});

      let newBounds = []
      var zoom = mMap.getZoom()

      if(zoom <= 9){
        newBounds = mMap.getBounds();
      }else{
        newBounds = mMap.getBounds().pad(-0.15);
      }
      
      //Used to pass data from here to sportRoutes.jsx
      getZoomLevel(mMap.getZoom());
      setQueryParam("zoomLevel", JSON.stringify(mMap.getZoom()))

      var mapCenter = calculateCenter(newBounds)
      setQueryParam("lat", mapCenter["lat"])
      setQueryParam("lng", mapCenter["lng"])

      var minLat = newBounds._southWest.lat,
      minLon = newBounds._southWest.lng,
      maxLat = newBounds._northEast.lat,
      maxLon = newBounds._northEast.lng;

      searchBody.params[0].bounds.min.lon = minLon;
      searchBody.params[0].bounds.min.lat = minLat;

      searchBody.params[0].bounds.max.lon = maxLon;
      searchBody.params[0].bounds.max.lat = maxLat;
    };

    const fetchRouteDetails = async (allRouteids) => {
      const body = {
        "method": "getFull",
        "params": [
            allRouteids,
            "nl"     
        ]
      }

     return await axios.post(DefaultLink, body)
    };
  
    const fetchRoutes = async () => {
      changeBounds();
      var groupId = []

      if(filters['lengthFilter']){
        searchBody.params[0]['length.min'] = filters['lengthFilter'].min * 1000;
        searchBody.params[0]['length.max'] = filters['lengthFilter'].max * 1000;
      }

      if(filters['kindFilter']){
        searchBody.params[0]['type.id'] = filters['kindFilter'];
      }

      if(filters['categoryFilter']){
        //Alle looproutes
        if(filters['categoryFilter'] === 12045 ){
          groupId.push(filters['categoryFilter']);
          searchBody.params[0]['group.id'] = groupId;
          searchBody.params[0]['type.id'] = 9;
        }
        //Alle mountainbikeroutes
        else if(filters['categoryFilter'] === 1933){
          groupId.push(filters["categoryFilter"]);
          searchBody.params[0]['group.id'] = groupId;
          searchBody.params[0]['type.id'] = 7;
        }
        //Ruiter knooppunt
        else if(filters['categoryFilter'] === 215841){
          searchBody.params[0]['owner.id'] === 215841;
        }
        //Specifieke filters
        else{
          groupId.push(filters["categoryFilter"])
          searchBody.params[0]['group.id'] = groupId;
        }
      }

      if(filters['pavedFilter']){
        groupId.push(filters['pavedFilter'])  

        //paardrijden is een uitzondering omdat die geen category filter heeft.
        if(filters['group.id'] === "16185"){
          groupId.push(filters['group.id']) 
        }

        searchBody.params[0]['group.id'] = groupId;
        searchBody.params[0]['group.match'] = "all";
      }

      if(filters['difficultyFilter']){
        searchBody.params[0]['difficulty.min'] = filters['difficultyFilter'].min;
        searchBody.params[0]['difficulty.max'] = filters['difficultyFilter'].max;
      }

      if(!isComboRoute){
        searchBody.params[0]['exclude.group.id'] = '55551';
      }
      else{
        searchBody.params[0]['exclude.group.id'] = null;
      }
      
      //Volledig leeg of geen group id ==> alles ophalen
      if(Object.keys(filters).length === 0 || filters['group.id'].length === 0){
        
        let allRoutes = []
        //Alle mountainbike routes over vlaanderen
        searchBody.params[0]['owner.id'] = [30581]
        searchBody.params[0]['group.id'] = [1933]

        //Fetch all mountainbike routes
        axios.post(DefaultLink, searchBody)
        .then(response => {
          allRoutes.push(response.data);

          //Fetch de rest van de sporttypes
          searchBody.params[0]['owner.id'] = []
          searchBody.params[0]['group.id'] = [16185,26841,12705,12045,42540]

          axios.post(DefaultLink, searchBody)
          .then(response => {
            allRoutes.push(response.data);
            setCombindedRoutesData(allRoutes);
          })
          .catch(error => {
            console.log(error)
          })
        })
        .catch(error => {
          console.log(error)
        })
      } 
      //Filtered op group id
      else{
        if(filters["categoryFilter"] == 215841){
          searchBody.params[0]['group.id'] = [];
          searchBody.params[0]['owner.id'] = 215841;
        }
        else if(filters['group.id'] !== 1933 && filters['categoryFilter'] !== 1933){
          searchBody.params[0]['owner.id'] = []
        }
        else{
          searchBody.params[0]['owner.id'] = [30581]
        }
        
        if(!filters['categoryFilter'] && !filters['pavedFilter'] && filters['kindFilter'] != 54950){
          searchBody.params[0]['group.id'] = filters['group.id'];
        }

        axios.post(DefaultLink, searchBody)
        .then(response => {
          setRoutesData(response.data)
        })
        .catch(error => {
          console.log(error)
        })
      }
    };

    const mapEvents = useMapEvents({
      moveend: () => {
        async function changeMapElements(){
          await fetchRoutes();
        }
        changeMapElements();
      },
      zoomstart: (event) => {
      },
    });

    return null;
};

export default MapEvents;